export function Loader({
  size = "w-16 h-16",
  fScreen = 'h-screen'
}) {
  return (
    <div className={`flex items-center justify-center ${fScreen} bg-white`}>
      <div
        className={`loader border-t-transparent border-solid rounded-full border-4 ${size} border-secondary animate-spin`}
      ></div>
    </div>
  );
}